<div class="actions">
  <div class="size">
    <div class="current">{{ size }}px</div>
    <p-slider [(ngModel)]="size" [min]="0" [max]="1600" [step]="10"></p-slider>
  </div>
  <p-menu [popup]="true" #thememenu [model]="themeOptions"></p-menu>
  <p-button (onClick)="thememenu.toggle($event)" icon="true">
    <fa-icon [icon]="faAdjust" [fixedWidth]="true"></fa-icon>
  </p-button>
</div>


<wm-modaltoolcontainer></wm-modaltoolcontainer>

<div class="container" [style.width.px]="size">
  <wm-a11yreport-artifact [artifact]="artifact"></wm-a11yreport-artifact>
</div>
